import { COOKIE_KEY } from "@/configs/global.config";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import useDeepCompareMemo from "./useDeepCompareMemo";

const useProfile = () => {
  const token = Cookies.get(COOKIE_KEY.ACCESS_TOKEN) as any;
  const profile = useDeepCompareMemo(token ? getPayloadJwt(token) : null);
  return profile;
};

export default useProfile;

export const getProfile = () => {
  try {
    const token = Cookies.get(COOKIE_KEY.ACCESS_TOKEN) as any;
    const decoded = jwtDecode(token);
    return decoded as any;
  } catch (e) {
    return null;
  }
};

export const getPayloadJwt = (token: string) => {
  try {
    const decoded = jwtDecode(token);
    return decoded as any;
  } catch (e) {
    return null;
  }
};
